export default __webpack_public_path__ + "static/media/component1.0fcc051a.png";